import { FunctionComponent} from 'preact';
import { useState } from 'preact/hooks';

const Favicon: FunctionComponent<{ domain: string }> = ({
  domain,
}: {
  domain: string;
}) => {
  const [url, setUrl] = useState(
    `https://www.google.com/s2/favicons?${new URLSearchParams({
      domain,
      sz: '24',
    })}`
  );

  const handleError = () => {
    const fallback = `chrome://favicon/${domain}`;
    if (url !== fallback) setUrl(fallback);
  };

  return <img src={url} onError={handleError} alt="" />;
};

export default Favicon;
